import { render, staticRenderFns } from "./hiring-detail.vue?vue&type=template&id=869483b0&scoped=true"
import script from "./hiring-detail.vue?vue&type=script&lang=js"
export * from "./hiring-detail.vue?vue&type=script&lang=js"
import style0 from "./hiring-detail.vue?vue&type=style&index=0&id=869483b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869483b0",
  null
  
)

export default component.exports